<template>
  <div v-show="!homeScreenStatus && !exerciseCompleted && !gameCompleted" class="game">
    <img id="game__background-house" src="@/assets/practices/pumpkin_clock/house.png" alt="house" />
    <div class="game__lives">
      <!-- Bug: Life container moves when it rerenders after user interaction. -->
      <ul>
        <li v-for="life in currentLives" :key="life">
          <img class="cauldron" src="@/assets/practices/pumpkin_clock/cauldronActive.svg" alt="cauldron" />
        </li>
        <li v-for="life in maxLives - currentLives" :key="life + 10">
          <img class="cauldron" src="@/assets/practices/pumpkin_clock/cauldronInactive.svg" alt="cauldron" />
        </li>
      </ul>
    </div>
    <div class="game__points">
      <p>Points: {{ playerScore }}</p>
    </div>
    <div v-show="!explanationStatus" class="game__pumpkin-grid">
      <Pumpkin
        :pumpkin-time="fiveExercises[currentExercise].answerOptions[0].time"
        :pumpkin-answer="fiveExercises[currentExercise].answerOptions[0].answer"
      />
      <Pumpkin
        :pumpkin-time="fiveExercises[currentExercise].answerOptions[1].time"
        :pumpkin-answer="fiveExercises[currentExercise].answerOptions[1].answer"
      />
      <Pumpkin
        :pumpkin-time="fiveExercises[currentExercise].answerOptions[2].time"
        :pumpkin-answer="fiveExercises[currentExercise].answerOptions[2].answer"
      />
    </div>
    <div v-show="!explanationStatus" class="game__instructions">
      <Instructions :instructions-clock="fiveExercises[currentExercise].clock" />
    </div>
    <div v-show="explanationStatus" :class="{ game__explanation: true, 'game__explanation--success': correctStatus }">
      <img
        class="game__explanation--clock"
        :src="require(`@/assets/practices/pumpkin_clock/${fiveExercises[currentExercise].clock}`)"
        alt="clock"
      />
      <!-- <img
        class="game__explanation--clock"
        src="@/assets/practices/pumpkin_clock/clocks/eight_fifty.svg"
        alt="clock"
      />-->
      <p v-if="correctStatus">Congrats! You did great!</p>
      <p v-else>{{ fiveExercises[currentExercise].explanation }}</p>
      <button @click="clickContinue">Continue</button>

      <div v-show="correctStatus" id="witch-happy"></div>
      <div v-show="!correctStatus" id="witch-sad"></div>
      <!-- <img
        class="game__explanation--witch-avatar"
        src="@/assets/practices/pumpkin_clock/witch_avatar.svg"
        alt="witch-avatar"
      />-->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// import { Howl } from 'howler';
import lottie from 'lottie-web/build/player/lottie';
import exercises from '@/assets/practices/data/pumpkin_clock/exercises.json';
import sounds from '@/packages/sounds/index.js';

export default {
  name: 'Game',
  components: {
    Pumpkin: () => import('@/components/practices/pumpkin_clock/Pumpkin.vue'),
    Instructions: () => import('@/components/practices/pumpkin_clock/Instructions.vue'),
  },
  data: () => ({
    exercises,
    fiveExercises: [],
  }),
  computed: {
    ...mapGetters({
      correctStatus: 'pumpkinClock/correctStatus',
      currentExercise: 'pumpkinClock/currentExercise',
      currentLives: 'pumpkinClock/currentLives',
      exerciseCompleted: 'pumpkinClock/exerciseCompleted',
      explanationStatus: 'pumpkinClock/explanationStatus',
      gameCompleted: 'pumpkinClock/gameCompleted',
      homeScreenStatus: 'pumpkinClock/homeScreenStatus',
      maxLives: 'pumpkinClock/maxLives',
      playerScore: 'pumpkinClock/playerScore',
    }),
  },
  created() {
    this.fiveExercises = this.getRandom(exercises, 5);
  },
  mounted() {
    const witchHappyAnimation = lottie.loadAnimation({
      container: document.getElementById('witch-happy'),
      renderer: 'svg',
      loop: true,
      autoplay: false,
      path: '/assets/practices/pumpkin_clock/animations/witch_happy.json',
    });
    const witchSadAnimation = lottie.loadAnimation({
      container: document.getElementById('witch-sad'),
      renderer: 'svg',
      loop: true,
      autoplay: false,
      path: '/assets/practices/pumpkin_clock/animations/witch_sad.json',
    });
    // When mounted, correctStatus === false. Have to run only until question is answered.
    witchHappyAnimation.play();
    witchSadAnimation.play();
  },
  methods: {
    checkGameOver() {
      if (
        (this.$store.state.pumpkinClock.exerciseCompleted && this.$store.state.pumpkinClock.currentLives <= 0) ||
        (this.$store.state.pumpkinClock.exerciseCompleted && this.$store.state.pumpkinClock.currentExercise >= 4)
      ) {
        this.$store.state.pumpkinClock.gameCompleted = true;
      } else {
        this.$store.state.pumpkinClock.currentExercise += 1;
      }
    },
    clickContinue() {
      sounds.globalButton.play();
      this.$store.state.pumpkinClock.explanationStatus = false;
      this.$store.state.pumpkinClock.exerciseCompleted = true;
      this.checkGameOver();
      if (!this.$store.state.pumpkinClock.gameCompleted) {
        this.$store.state.pumpkinClock.exerciseCompleted = false;
      }
      this.$confetti.stop();
      this.$store.state.pumpkinClock.correctStatus = false;
    },
    getRandom(arr, n) {
      const result = new Array(n);
      let len = arr.length;
      const taken = new Array(len);
      if (n > len) throw new RangeError('getRandom: more elements taken than available');
      while (n--) {
        const x = Math.floor(Math.random() * len);
        result[n] = arr[x in taken ? taken[x] : x];
        taken[x] = --len in taken ? taken[len] : len;
      }
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.game {
  @include container;
  color: $pumpkin-clock-color-main;
  background-image: url('~@/assets/practices/pumpkin_clock/background_main_game.png');
  background-repeat: no-repeat;
  background-size: cover;
  font-family: 'RimouskiSb-Regular';

  #game__background-house {
    @include flex-center;
    position: absolute;
    top: -1vh;
    width: 70vw;
  }

  .game__lives {
    @include flex-center;
    background-color: #f1f1e87e;
    border: 0.75vh solid black;
    border-radius: 1.75vw;
    height: 11vh;
    position: absolute;
    right: 2vw;
    top: 2vh;

    ul {
      @include flex-center;
      list-style: none;
      margin: 0;

      li {
        margin: 1vh 1.5vw;

        .cauldron {
          height: 8vh;
        }
      }
    }
  }

  .game__points {
    @include flex-center;
    background-color: white;
    border: 0.75vh solid black;
    border-radius: 5vw;
    color: black;
    font-size: 1.5em;
    font-family: 'VanillaExtractRegular';
    height: 11vh;
    left: 2vw;
    padding: 0 2vw;
    position: absolute;
    top: 2vh;
  }

  .game__pumpkin-grid {
    align-items: center;
    display: grid;
    grid-template: 'column1 column2 column3';
    grid-template-columns: min-content min-content min-content;
    grid-gap: 5vw;
    justify-content: center;
    transform: translateY(-7.5vh);

    .column1 {
      grid-area: column1;
    }
    .column2 {
      grid-area: column2;
    }
    .column3 {
      grid-area: column3;
    }
  }

  .game__instructions {
    bottom: 2vh;
    position: absolute;
    z-index: 3;
  }

  .game__explanation {
    @include flex-center;
    background-color: #00000070;
    border: 1vh solid $pumpkin-clock-color-danger;
    border-radius: 7.5vh;
    bottom: 1vw;
    flex-direction: column;
    height: 75vh;
    position: absolute;
    width: 95vw;

    &--success {
      border: 1vh solid $pumpkin-clock-color-success;
    }

    p {
      font-family: 'RimouskiSb-Regular';
      margin-top: 10vh;
      text-align: center;
      width: 75%;
    }

    .game__explanation--clock {
      height: 32vh;
      position: absolute;
      top: -15vh;
    }

    .game__explanation--witch-avatar {
      bottom: -2.8vh;
      height: 40vh;
      position: absolute;
      right: 0;
    }
  }
}

#witch-happy,
#witch-sad {
  bottom: -2.8vh;
  height: 40vh;
  position: absolute;
  right: 0;
  width: 40vh;
}
</style>
